export default {"src":"/_next/static/media/Copy.289cbe94.svg","height":16,"width":17,"blurWidth":0,"blurHeight":0};